<template>
    <div>
        <b-collapse  :open="true" v-for="(component,index) in components" :key="index" :aria-id="component.componentName+''+index" >
            <a  @click="$emit('setFormComponent',component,indexMain)" class="text-break-all is-flex ai-center" slot="trigger" slot-scope="props" href="#" v-scroll-to="'#M'+component.key" :class="(asideMenu === component.key)?'text-success-form':''"  :slot-scope="component.componentName+''+index" :title="component.componentName" >
                <span class="is-flex ai-center">
                        <b-icon v-if="component.children.length !== 0" :class="{'is-hidden position-absolute':component.children.length === 0 || props.open === true}" pack="fas" size="is-small" icon="plus-circle" class="has-text-grey-light is-size-7"></b-icon>
                        <b-icon v-if="component.children.length !== 0" :class="{'is-hidden position-absolute':component.children.length === 0 || props.open === false}" pack="fas" size="is-small" icon="minus-circle" class="has-text-grey-light is-size-7"></b-icon>
                        <span class=" has-text-weight-normal pd-x-5 subMenu" :class="(count > 0)?'is-size-6':'is-size-5'">{{component.componentName}}</span>
                        <span v-if="component.children.length !== 0 && hiddenCompelete === false"  class="pd-x-5 word-break-keep-all" :class="[(count > 0)?'is-size-6':'is-size-5',{'text-success-form':getCompelete(component.key) === true}]">{{getCompeleteStep(component.children)}}/{{component.children.length}}</span>
                    <b-icon v-if="getCompelete(component.key) === true && hiddenCompelete === false" pack="fas" size="is-small" icon="check-circle" class="text-success-form is-size-7"></b-icon>
                </span> 
            </a>
            <ul v-if="component.children.length !== 0" :aria-controls="component.componentName+''+index" class="is-paddingless ls-none ">
                <div v-for="(childrens,childrensIndex) in component.children" :key="childrensIndex">
                    <li  ><a class="th text-break-all is-flex ai-center"  @click="$emit('setFormComponent',component,indexMain)" href="#" v-scroll-to="'#M'+childrens.key"  :title="childrens.componentName">
                            <span class="is-size-6 has-text-weight-normal  is-contents">
                                <span class="pd-x-5 subMenu">{{childrens.componentName}}</span>
                                <b-icon v-if="getCompelete(childrens.key) === true && hiddenCompelete === false" pack="fas" size="is-small" icon="check-circle" class=" text-success-form is-size-7 "></b-icon>
                            </span>  
                        </a>
                    </li>
                    <FormAside 
                        v-if="childrens.children.length !== 0" 
                        :count="count+1"
                        :components="childrens.children" 
                        :getCompelete="getCompelete"
                        :getCompeleteStep="getCompeleteStep"
                        :hiddenCompelete="hiddenCompelete"
                        :indexMain="indexMain"
                    />
                </div>
            </ul>
        </b-collapse>
    </div>
</template>

<script>
    export default {
        name:'FormAside',
        props: {
            count: {
                type: Number,
                default:0
            },
            components:{},
            asideMenu:{},
            getCompelete:{},
            getCompeleteStep:{},
            hiddenCompelete:{},
            indexMain:0
        }
    }
</script>
<style scoped>

</style>
